import React, { ReactNode } from 'react';
import { styled } from 'styled-components';

import { Spacer } from '../Spacer';

const Description = styled.span`
  color: #a3a6ab;
  font-size: 12px;
  line-height: 14px;
  font-weight: 500;
  word-break: keep-all;
`;
const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
`;

interface StatusProps {
  branch?: ReactNode;
  statusMessage: ReactNode;
  description: string;
}
export const Status = (props: StatusProps) => {
  const { branch, statusMessage, description } = props;

  return (
    <StatusWrapper>
      {branch}
      {statusMessage}
      <Spacer width="12px" />
      <Description>{description}</Description>
    </StatusWrapper>
  );
};
